export default __webpack_public_path__ + "811f6583954a47e4e7a72201688fb1cc.ttf";